import React from 'react';
import { map } from 'lodash';

import { CategoryLayout } from 'js/components/Charts/CategoryLayout';
import { scaleLinear } from '@visx/scale';

import QuestionDifferential from './QuestionDifferential';
import ArrowMarker from '../Differential/ArrowMarker';
import { DEFAULT_STALE_DATA_MAX_AGE_MS, isStale } from './utils';

import styles from './AssessmentDifferential.module.scss';

const yScale = scaleLinear({ domain: [0, 1], range: [100, 0] });

export const AssessmentDifferentialChart = ({
  assessments,
  showStale = false,
  staleAge = DEFAULT_STALE_DATA_MAX_AGE_MS,
  categoryLookups,
  summaryMetrics,
  renderHeaderActions,
}) => {
  const [before, after] = assessments;

  return (
    <CategoryLayout
      categoryLookups={categoryLookups}
      categories={summaryMetrics?.categories}
      stickyCategories
      fullNameBar={false}
      questionSets={summaryMetrics?.questionSets}
      renderHeaderActions={renderHeaderActions}
      renderQuestionSet={(questionSet, palette) => {
        return map(questionSet.questions, (question) => {
          const beforeQuestion =
            before?.questionSets?.[questionSet.key]?.questions?.[
              question.key
            ] ?? null;
          const afterQuestion =
            after?.questionSets?.[questionSet.key]?.questions?.[question.key] ??
            null;

          const isStaleAfter =
            showStale &&
            isStale(afterQuestion?.insertedAt, after?.insertedAt, staleAge);
          const isStaleBefore =
            showStale &&
            isStale(beforeQuestion?.insertedAt, before?.insertedAt, staleAge);

          return (
            <div key={question.key} className={styles['differential-item']}>
              <div className={palette} />
              <svg width={80} height={120}>
                <defs>
                  <ArrowMarker id="arrow" />
                </defs>
                <g transform={`translate(0, 10)`}>
                  <QuestionDifferential
                    from={beforeQuestion}
                    isStaleFrom={isStaleBefore}
                    to={afterQuestion}
                    isStaleTo={isStaleAfter}
                    arrowId={'arrow'}
                    yScale={yScale}
                  />
                </g>
              </svg>
              <p className={styles['item-label']}>{question.text}</p>
            </div>
          );
        });
      }}
    />
  );
};

export default AssessmentDifferentialChart;
